$(document).ready(function () {
    jQuery(window).scroll(function () {
        if (jQuery(this).scrollTop() > 1) {
            jQuery("#header-fix").addClass("sticky");
        } else {
            jQuery("#header-fix").removeClass("sticky");
        }
    });

    const isLinkExternal = (link_element) => {
        return link_element.host !== window.location.host && link_element.host !== "";
    };

    $("a").each(function () {
        if (isLinkExternal(this)) {
            $(this).attr("data-toggle", "modal");
            $(this).attr("data-target", "#confirmationModal");
            $(this).attr("data-redirection", this.href);
        }
    });

    $("#confirmationModal").on("show.bs.modal", function (event) {
        var button = $(event.relatedTarget);
        var recipient = button.data("redirection");
        $("#confirmationOk").unbind().click(() => {
            window.open(recipient, '_blank');
        })
    });
});